module.exports = __webpack_public_path__ + "static/media/file-type-cover.c6c1951b.svg";